'use client'

import * as React from 'react'
import { cn } from '@cocoonspace/ui/lib/utils'
import { Separator as SeparatorPrimitive } from 'radix-ui'

const Separator = React.forwardRef<
	React.ElementRef<typeof SeparatorPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>
>(
	(
		{ className, orientation = 'horizontal', decorative = true, ...props },
		ref,
	) => (
		<SeparatorPrimitive.Root
			className={cn(
				'bg-border shrink-0',
				orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
				className,
			)}
			decorative={decorative}
			orientation={orientation}
			ref={ref}
			{...props}
		/>
	),
)

Separator.displayName = SeparatorPrimitive.Root.displayName

export { Separator }
